import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { useStore } from '@modules';

import Illustration from '@components/Illustration';
import MainLayout from '@layouts/MainLayout';

import Invitation from './Invitation';
import RefEarn from './RefEarn';
import RewardsHistory from './RewardsHistory';
import { withCustomProvider } from './context';
import PeopleAndRabbit from './people-and-rabbit.svg';

import style from './Invite.scss';

const cn = bemCssModules(style, 'Invite');
const ti = getTestId('Invite');

const illustrationImages = [<PeopleAndRabbit />, '/img/stars-and-carrots.png'];

export const Invite: CustomFC = ({ className }) => {
  const { t } = useTranslation();

  const [store] = useStore();
  const { transactions } = store;
  const { referral } = transactions;

  const referralCount = referral.data?.count || 0;

  const getLink = () =>
    'https://help.mercuryo.io/hc/en-gb/sections/14494990593309-Mercuryo-Referrals-';

  return (
    <MainLayout>
      <div className={cn(null, [className])} data-testid={ti()}>
        <div className={cn('inner-wrapper')}>
          <div className={cn('title')}>
            {t('referral.invite_friend')} {t('referral.earn_money')}
          </div>
          <div className={cn('earn')}>{t('referral.earn')}</div>
          <div>
            <Invitation className={cn('invitation')} />
            {referralCount > 0 ? (
              <RefEarn className={cn('ref-earn')} />
            ) : (
              <p className={cn('no-referrals')}>{t('referral.no_referrals')}</p>
            )}
          </div>
          <RewardsHistory />
          <div className={cn('links')} data-testid={ti('links')}>
            <a
              className="link"
              href="https://mercuryo.io/legal/referral"
              rel="noreferrer"
              target="_blank"
            >
              {t('referral.referral_terms')}
            </a>
            <span className={cn('dot')} />
            <a className="link" href={getLink()} rel="noreferrer" target="_blank">
              {t('referral.questions')}
            </a>
          </div>
        </div>
        <Illustration className={cn('illustration')} images={illustrationImages} />
      </div>
    </MainLayout>
  );
};

export default withCustomProvider(Invite);
